import { Injectable } from '@angular/core';

import { LocalStorageKey, LocalStorageService } from 'app/services/local-storage.service';
import { EnableClassTelemetry } from 'app/services/otel.service';
import {
  ConfigurationItemListOptions,
  IConfigurationItemListOptions,
} from '../models/configuration-item-list-options.model';

@EnableClassTelemetry()
@Injectable()
export class ConfigurationItemListOptionsService {
  private readonly _key = LocalStorageKey.CONFIGURATION_ITEM_LIST_OPTIONS;

  constructor(private localStorageService: LocalStorageService) {}

  get(): ConfigurationItemListOptions {
    const item = this.localStorageService.getItem(this._key) as IConfigurationItemListOptions;

    if (!item) {
      return ConfigurationItemListOptions.create();
    }

    return new ConfigurationItemListOptions(item.sort, item.filter, item.showHidden);
  }

  set(options: ConfigurationItemListOptions): void {
    this.localStorageService.setItem(this._key, options);
  }
}
